const getSubStepWithOptions = (workflowCompletion: any, subStepId?: string) => {
  if (!subStepId) return undefined;
  return workflowCompletion?.workflow?.steps
    ?.flatMap((step: any) => step?.subSteps ?? [])
    ?.find((subStep: any) => subStep?.id === subStepId);
};

export const updateNextWorkflowStep = (
  workflowCompletion: any,
  setWorkflowCompletion: (o: any) => void,
  onComplete: () => void,
) => {
  const currentSubStepIndex =
    workflowCompletion?.currentStep?.subSteps?.findIndex(
      (subStep: any) => subStep.id === workflowCompletion.currentSubStep.id,
    ) || 0;
  const currentStepIndex =
    workflowCompletion?.workflow?.steps?.findIndex(
      (step: any) => step.id === workflowCompletion.currentStep.id,
    ) || 0;

  if (
    currentSubStepIndex + 1 <
    workflowCompletion.currentStep.subSteps.length
  ) {
    const nextSubStepId =
      workflowCompletion?.currentStep?.subSteps[currentSubStepIndex + 1]?.id;
    setWorkflowCompletion({
      ...workflowCompletion,
      currentSubStep:
        getSubStepWithOptions(workflowCompletion, nextSubStepId) ??
        workflowCompletion?.currentStep?.subSteps[currentSubStepIndex + 1],
      direction: 'FORWARD',
    });
  } else if (currentStepIndex + 1 < workflowCompletion.workflow.steps.length) {
    setWorkflowCompletion({
      ...workflowCompletion,
      currentStep: workflowCompletion?.workflow?.steps[currentStepIndex + 1],
      currentSubStep:
        workflowCompletion?.workflow?.steps[currentStepIndex + 1]?.subSteps[0],
      direction: 'FORWARD',
    });
  } else {
    onComplete();
  }
};

export const updatePreviousWorkflowStep = (
  workflowCompletion: any,
  setWorkflowCompletion: (o: any) => void,
) => {
  const currentSubStepIndex =
    workflowCompletion?.currentStep?.subSteps?.findIndex(
      (subStep: any) => subStep.id === workflowCompletion.currentSubStep.id,
    ) || 0;
  const currentStepIndex =
    workflowCompletion?.workflow?.steps?.findIndex(
      (step: any) => step.id === workflowCompletion.currentStep.id,
    ) || 0;

  if (currentSubStepIndex - 1 >= 0) {
    const previousSubStepId =
      workflowCompletion?.currentStep?.subSteps[currentSubStepIndex - 1]?.id;
    setWorkflowCompletion({
      ...workflowCompletion,
      currentSubStep:
        getSubStepWithOptions(workflowCompletion, previousSubStepId) ??
        workflowCompletion?.currentStep?.subSteps[currentSubStepIndex - 1],
      direction: 'BACKWARD',
    });
  } else {
    setWorkflowCompletion({
      ...workflowCompletion,
      currentStep: workflowCompletion?.workflow?.steps[currentStepIndex - 1],
      currentSubStep:
        workflowCompletion?.workflow?.steps[currentStepIndex - 1]?.subSteps[
          workflowCompletion.workflow.steps[currentStepIndex - 1].subSteps
            .length - 1
        ],
      direction: 'BACKWARD',
    });
  }
};
